import React from 'react'
import Bookingtomulaqaat from '../components/Bookingtomulaqaat'
import Reviews from '../components/Reviews'
import Faq from '../components/Faq'
import Subscribe from '../components/Subscribe'
import Eventsection from '../components/Eventsection'
import { Helmet } from "react-helmet-async"

const Event = () => {
  return (
    <>
      <Helmet>
      <title>Events page • The Event House</title>
    </Helmet>

     {/* section 1 */}

    <Eventsection/>

     {/* section 2 */}
     <Bookingtomulaqaat />

     {/* section 3 */}
     <Reviews />

     {/* section 4 */}
      <Faq />

      {/* section 5 */}
        <Subscribe />

    </>
  )
}

export default Event
